import { withinSection } from '../../../../../shared/components/section-trail';
import { FLEET_TAB_LABELS, fleetTabPath } from '../../../fleet.paths';

/** The crumbs above a unit's page, a spare trailer's included: Assets › Fleet › Units. */
export const UNITS_TRAIL = withinSection('fleet', { label: FLEET_TAB_LABELS.units, to: fleetTabPath('units') });
